module.exports = __webpack_public_path__ + "static/img/7.650c3a7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/12/eng/7.png
// module id = 7HMX
// module chunks = 0